__webpack_require__.p = "/BeatLab/";